import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item"]

  connect() {
    this.inputTarget.addEventListener("input", this.onInput)
    this.inputTarget.addEventListener("keydown", this.onKeyDown)
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.onInput)
    this.inputTarget.removeEventListener("keydown", this.onKeyDown)
  }

  onInput = () => {
    this.filter()
  }

  onKeyDown = (event) => {
    if (event.key === 'Escape') {
      this.clear()
    }
  }

  filter() {
    const query = this.inputTarget.value.trim()
    const pattern = new RegExp(query, 'i')

    this.itemTargets.forEach(item => {
      const searchText = item.dataset.search || item.textContent
      const matches = pattern.test(searchText)
      
      item.classList.toggle('d-none', !matches)
    })
  }

  clear() {
    this.inputTarget.value = ''
    this.filter()
    this.inputTarget.focus()
  }
} 
